import script from "./Section9Footer.vue?vue&type=script&lang=ts&setup=true"
export * from "./Section9Footer.vue?vue&type=script&lang=ts&setup=true"

import "./Section9Footer.vue?vue&type=style&index=0&id=3243cb76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3243cb76"]])

export default __exports__